import { render, staticRenderFns } from "./ProductBasicInfo.vue?vue&type=template&id=13e4e26f&scoped=true&"
import script from "./ProductBasicInfo.vue?vue&type=script&lang=js&"
export * from "./ProductBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductBasicInfo.vue?vue&type=style&index=0&id=13e4e26f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4e26f",
  null
  
)

export default component.exports